export default __webpack_public_path__ + "51321b879910c8aa9d7296c47907cbe8.png";